import { axiosJWT } from 'modules/axios'
import { APP_CONFIG } from 'services/app-config'

export const fetchContentfulResource = (resource, params) =>
  axiosJWT({
    method: 'GET',
    url: `${APP_CONFIG.sales_cluster}/v1/static-content/contentful/${resource}`,
    params,
  }).then(resp => resp.data)
